import React from 'react';
import { useQuery } from 'react-query';
import HeaderPage from '../../../../components/HeaderPage/HeaderPage';
import { main_color_50 } from '../../../../styles/_variables';

import styles from './NotificationsList.module.scss'
import { Spin } from 'antd';

import useHeader from '../../../../hooks/useHeader';
import NotificationItem from '../NotificationItem/NotificationItem';
import { useUserStore } from '../../../../store/useUser';
import { getNotificationByClubUser, getNotificationByUser } from '../../../../service/userNotification';
import Filter, { FilterItem } from '../../../../components/Filter/CustomFilter';
import useSearchParam from '../../../../hooks/useQueryParams';

const NotificationsList: React.FC = () => {
  const [searchState, setSearchState] = useSearchParam<string>('isRead');
  
  if(!searchState) setSearchState('false');

  const userId = useUserStore(state => state.id);
  const profile = useUserStore(state => state.profile);
  const club = useUserStore(state => state.club);

  const { data: notifications, refetch, isFetching } = useQuery(
    ['notifications', userId, searchState],
    () => {
      if (profile === "Clubista"){
        return getNotificationByUser(userId, searchState);
      } else if (profile === "Criador" || profile === "Mediador"){
        return getNotificationByClubUser(userId, club?.id, searchState);
      }
      return [];
    },
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  useHeader({ header: 'Minhas Notificações' });

  return (
      <div className={styles.container}>
        <HeaderPage header="Minhas Notificações" bageColor={main_color_50}/>
        <Filter>
          <FilterItem 
            onClick={e => setSearchState('false')} 
            active={searchState === 'false'}>
              Não lidas
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchState('true')} 
            active={searchState === 'true'}>
              Lidas
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchState('all')} 
            active={searchState === 'all'}>
              Todas
          </FilterItem>
        </Filter>
        <Spin spinning={isFetching}>
          {notifications?.map(notification => 
            <NotificationItem 
              notification={notification}
              refetchData={refetch}
            />
          )}
        </Spin>
        
      </div>
  )
}

export default NotificationsList;